import { registerPlugin } from '@capacitor/core'

/**
 * The bridge handle for the local `NativeLocationChallengePlugin` (#1696) —
 * raw `application(_:didReceiveRemoteNotification:fetchCompletionHandler:)`
 * on iOS (`ios/App/CapApp-SPM/Sources/CapApp-SPM/
 * NativeLocationChallengePlugin.swift`), FCM data-message delivery on
 * Android (`android/.../NativeLocationChallengePlugin.java`). Same
 * "app-local native plugin, not an npm package" pattern as
 * `nativeNotifications.js` (#1695) — see that file's own comment for why.
 *
 * Deliberately a SEPARATE bridge/plugin from `NativeNotifications` (#1695)
 * even though both ultimately arrive via a push: the silent/data-only
 * LOCATION_CHALLENGE payload never carries a displayable notification
 * (§8.3's "no PII/coordinates, only type/challengeId/nonce" limit) and
 * needs a fundamentally different OS-level delivery path on both platforms
 * — see the native plugin files' own headers for the iOS/Android specifics.
 *
 * Surface (implemented natively, called from `adapters/location.js`):
 *  - `completeChallenge()` -> `{}` — tells the native layer the JS-side
 *    fetch/sample/submit flow is done. Meaningful on iOS (releases
 *    `fetchCompletionHandler`, see that plugin's own budget comment); a
 *    genuine no-op on Android, present only so `location.js` can call the
 *    same two methods on both platforms.
 *  - `getPendingChallenge()` -> `{data: {challengeId, nonce}|null}` — a
 *    silent push delivered before any JS listener attached (cold start),
 *    read once. Mirrors `NativeNotifications.getLastTappedPush`.
 *  - Events: `'locationChallengeReceived'` — `{challengeId, nonce}`.
 */
export const NativeLocationChallenge = registerPlugin('NativeLocationChallenge')
